import { takeEvery, call } from 'redux-saga/effects';
import { REGISTRATION_REDIRECT } from 'shared_redux/actions';
import history from 'shared_redux/history';

/**
 * Saga to handle redirection
 * Instead of directly calling history.push, all navigation actions
 * should go through this saga to centralize routing logic
 */
function* handleRedirect(action) {
    const { path } = action;
    yield call(history.push, path);
}

/**
 * Routing saga that handles navigation actions
 */
export default function* RoutingSaga() {
    yield takeEvery(REGISTRATION_REDIRECT, handleRedirect);
} 